import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import toPairs from 'lodash.topairs';
import isNil from 'lodash.isnil';
import get from 'lodash.get';
import {
    getCutscoresObjectFromThresholds,
    getThresholdsByMeasureGradePeriod,
} from '../../../utils/shared/interpReducerHelpers';
import { MEASURE } from '../../../constants/shared/MeasuresConstants';

const { SPELLING } = MEASURE;

export const getSharedRatesSection = scoreObject => {
    const { score, maxScore, wscScore } = scoreObject;
    return {
        [SPELLING]: (
            <>
                Correct Spelling Sequence (CSS):
                <strong>{` ${score}/${maxScore}`}</strong>
                <br />
                Words Correct (WSC): <strong>{` ${wscScore}`} Correct</strong>
            </>
        ),
    };
};

export const buildRunningGirlLevels = (interps, defaultColorList = []) => {
    if (isEmpty(interps)) return defaultColorList;

    const colorList = defaultColorList.map((level, index) =>
        interps.includes(level) ? level : defaultColorList[index - 1],
    );

    return colorList.some(color => isNil(color))
        ? colorList.map((level, index) => (!isNil(level) ? level : colorList[index + 1]))
        : colorList;
};

export const getRunningGirlsParams = (
    interps,
    grade,
    period,
    measureScores,
    getRatesSection,
    getMeasureName,
    availableTitleMeasure,
) => {
    return toPairs(measureScores).map(([measureKey, scoreObject]) => {
        const thresholds = getThresholdsByMeasureGradePeriod(interps, measureKey, grade, period);
        const cutScores = getCutscoresObjectFromThresholds(thresholds);
        const isAvailableTitle = !isEmpty(cutScores) || availableTitleMeasure.includes(measureKey);

        return {
            measureKey,
            scoreObject,
            measureName: getMeasureName(measureKey),
            ratesSection: getRatesSection(scoreObject, measureKey),
            cutScores,
            isAvailableTitle,
        };
    });
};

export const DefaultRatesSection = ({ scoreSection }) => (
    <div className="rates">
        Score: <strong>{scoreSection}</strong>
    </div>
);

DefaultRatesSection.defaultProps = {
    scoreSection: '',
};

DefaultRatesSection.propTypes = {
    scoreSection: PropTypes.oneOfType([PropTypes.func, PropTypes.number, PropTypes.string]),
};

export const getCorrectCutScores = (interps, thresholds) =>
    interps.reduce((acc, interp) => {
        const currentScoreThreshold = get(
            thresholds.find(threshold => threshold.interp === interp),
            'scoreThreshold',
            null,
        );
        return acc.includes(currentScoreThreshold)
            ? [...acc, null]
            : [...acc, currentScoreThreshold];
    }, []);

export const MIDDLE_FLAG_POSITION = 50;

export const getMiddleFlagPosition = (cutScores, goal) =>
    cutScores[cutScores.indexOf(goal) + 1] === null ? 0 : MIDDLE_FLAG_POSITION;
